/**
 * Styled card wrapper for auth screens.
 */
import * as React from 'react';

/** Props for {@link AuthCard}. */
interface AuthCardProps {
  children: React.ReactNode;
}

/** Centered glass card that wraps every login / setup / reset view. */
export const AuthCard: React.FC<AuthCardProps> = ({ children }) => {
  return <div className="login-card">{children}</div>;
};
